import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { feedbackModel } from "src/app/models/settings.model";
import { SettingsService } from "src/app/services/settings.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-setting-feedback-dailog",
  templateUrl: "./setting-feedback-dailog.component.html",
  styleUrls: ["./setting-feedback-dailog.component.scss"],
})
export class SettingFeedbackDailogComponent implements OnInit,OnDestroy {
  feed: string;
  spin: boolean = false;
  isDisable: boolean = false;
  products:any[]=[];
  private destroy$ = new Subject<void>();
  constructor(
    private dialogRef: MatDialogRef<SettingFeedbackDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private settingService: SettingsService,
    private snackBar: MatSnackBar
  ) {}
  feedBackForm: FormGroup = new FormGroup({
    specify: new FormControl(),
    othersReason: new FormControl(),
    comment: new FormControl(),
  });

  ngOnInit(): void {
    this.data?.selectedProductIds.forEach((productId)=>{
      const product={
        productId:productId,
        name:productId == 1 ? 'shipyard' : productId == 2 ? 'priceyard' : productId == 10 ? 'netyard' : 'planyard',
        img:"../../../../assets/images/application-icons/"+(productId == 1 ? 'shipyard' : productId == 2 ? 'priceyard' : productId == 10 ? 'netyard' : 'planyard')+"-icon.svg"
      }
      this.products.push(product);
    })
  }

  close(e?) {
    if (e === "Submit") {
      this.submitFeedBack(e);
    } else {
      this.dialogRef.close(e);
    }
  }

  submitFeedBack(e) {
    this.spin = true;
      const payload: feedbackModel = {
        feedback: this.feed,
        specify: this.feedBackForm.value.specify || null,
        otherReason: this.feedBackForm.value.othersReason || null,
        comment: this.feedBackForm.value.comment,
        productId: this.data?.selectedProductIds,
      };
      this.settingService.SaveFeedback(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: "center",
              data: {
                title: "Feedback submit successfully.",
                action: "Dismiss",
                type: "success",
              },
            });
            this.spin = false;
            this.dialogRef.close(e);
        },
        error: (err) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err.error.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
         }
      });
  }
  onchange(event, control?) {
    this.removeValidator(this.feedBackForm);
    if (event.value) {
      this.feed = event.value;
      this.isDisable = true;
    }
    if (event.value === "Others" ||event.value === "I am switching to another software") {
      this.addValidation(control);
    }
  }
  addValidation(control) {
    this.feedBackForm.get(control).setValidators(Validators.required);
    this.feedBackForm.get(control).updateValueAndValidity();
  }

  removeValidator(feedBackForm: FormGroup) {
    for (const key in feedBackForm.controls) {
      if(key !== 'comment'){
        feedBackForm.get(key).clearValidators();
        feedBackForm.get(key).setValue(null);
        feedBackForm.get(key).setErrors(null);
        feedBackForm.get(key).setValidators(null);
        feedBackForm.get(key).updateValueAndValidity();
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
